// One tone of an ordered dither, as an SVG pattern. The die and the glow
// under the roll button fill with these. The cells are whole screen pixels.

import { TUMBLE_DITHER_CELL_PX } from '../constants';
import { svg } from '../lib/svg';

/** The order the cells of a four by four tile turn on, so every tone is an even spread. */
const BAYER_ROWS: readonly (readonly number[])[] = [
  [0, 8, 2, 10],
  [12, 4, 14, 6],
  [3, 11, 1, 9],
  [15, 7, 13, 5],
];
const TILE_CELLS = BAYER_ROWS.length;
const TILE_PX = TUMBLE_DITHER_CELL_PX * TILE_CELLS;

/** A tone is how many cells of the tile are lit, from none to all. */
export const DITHER_TONE_COUNT = TILE_CELLS * TILE_CELLS;

/** `groundClass` fills the tile under the lit cells. With none, the page shows between them. */
export const createTonePattern = (
  id: string,
  litCells: number,
  lightClass: string,
  groundClass: string | null,
): SVGPatternElement =>
  svg('pattern', { id, width: TILE_PX, height: TILE_PX, patternUnits: 'userSpaceOnUse' }, [
    ...(groundClass ? [svg('rect', { class: groundClass, width: TILE_PX, height: TILE_PX })] : []),
    ...BAYER_ROWS.flatMap((row, rowIndex) =>
      row.flatMap((order, columnIndex) =>
        order < litCells
          ? [
              svg('rect', {
                class: lightClass,
                x: columnIndex * TUMBLE_DITHER_CELL_PX,
                y: rowIndex * TUMBLE_DITHER_CELL_PX,
                width: TUMBLE_DITHER_CELL_PX,
                height: TUMBLE_DITHER_CELL_PX,
              }),
            ]
          : [],
      ),
    ),
  ]);
